import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@cb/solaris-react/Components/Interactive/Button/Button';
import ButtonLink from '@cb/solaris-react/Components/Navigation/ButtonLink';
import { Scheme } from '@cb/solaris-react/Constants/System';
import styled from 'styled-components';
import useConfiguration from '../../../../Hooks/UseConfiguration';
import Icon from '@cb/solaris-react/Components/Content/Icon';
export default function HelpSlideout(props) {
    const { close } = props;
    const config = useConfiguration();
    return (_jsxs(Vertical, { children: [_jsxs(Horizontal, { children: [_jsxs("h3", { children: [_jsx(StyledIcon, { name: "help" }), "Help"] }), _jsx(Button, { scheme: Scheme.shade6, onClick: close, children: "Close" })] }), _jsxs(ButtonLink, { scheme: Scheme.shade6, href: config.productConfig.docs, target: "_blank", children: [_jsx(StyledIcon, { name: "book" }), "Documentation"] }), _jsxs(ButtonLink, { scheme: Scheme.shade6, href: config.productConfig.mattermost, target: "_blank", children: [_jsx(StyledIcon, { name: "chats" }), "Mattermost"] })] }));
}
const Horizontal = styled.div `
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`;
const Vertical = styled.div `
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacing.sm};
`;
const StyledIcon = styled(Icon) `
	margin-right: ${({ theme }) => theme.spacing.sm};
	font-weight: 500;
`;
//# sourceMappingURL=HelpSlideout.js.map